import { useEffect, useState } from '@max/max';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { getUserInfo, login } from '@nibfe/mkt-user-api';
export const useUserInfo = (needLogin = false) => {
    const ctx = useMonitorEngineContext();
    const [userInfo, setUserInfo] = useState({
        token: ctx?._runtimeInfo?.commonParams?.token || '',
        avatarURL: '',
        uuid: ctx?._runtimeInfo?.commonParams?.uuid || '',
        userId: ctx?._runtimeInfo?.commonParams?.userId || '',
        userName: '',
        done: false,
        unionId: ''
    });
    useEffect(() => {
        // 获取用户信息
        (async () => {
            if (userInfo.userId && userInfo.token) {
                setUserInfo({
                    ...userInfo,
                    done: true
                });
            }
            else {
                const result = await getUserInfo();
                if (result.userId) {
                    setUserInfo({
                        ...result,
                        done: true
                    });
                }
                else if (needLogin) {
                    await login();
                }
                else {
                    setUserInfo({
                        ...userInfo,
                        done: true
                    });
                }
            }
        })();
    }, []);
    return {
        userInfo
    };
};
